import React from 'react';
import { Hero } from '../components/sections/Hero';
import { TrustStrip } from '../components/sections/TrustStrip';
import { Features } from '../components/sections/Features';
import { HowItWorks } from '../components/sections/HowItWorks';
import { Privacy } from '../components/sections/Privacy';
import { FAQ } from '../components/sections/FAQ';
import { CTA } from '../components/sections/CTA';

const Home = () => {
  return (
    <main>
      <Hero />
      <TrustStrip />
      <Features />
      <HowItWorks />
      <Privacy />
      <FAQ />
      <CTA />
    </main>
  );
};

export default Home;